<div class="mfunsPlayer-controller-mask">
    <div class="mfunsPlayer-controller">
        <div class="mfunsPlayer-controller-wrap "">
        <div class=" mfunsPlayer-controller-left">
            <div class="mfunsPlayer-controller-player-btn icon-play"> </div>
            {{ if video.length>1}}
            <div class="mfunsPlayer-controller-skip icon-next"></div>
            {{ /if }}
            <div class="mfunsPlayer-bar-wrap">
                <div class="currentTime">00:00</div>
                <div class="mfunsPlayer-bar">

                    <div class="mfunsPlayer-bar-mark hidden"></div>
                    <div class="mfunsPlayer-bar-preview">
                        <div class="mfunsPlayer-bar-preview-wrap">
                            <div class="mfunsPlayer-barTime"></div>
                        </div>

                    </div>
                    <div class="mfunsPlayer-bufferedBar"></div>
                    <div class="mfunsPlayer-playedBar">
                        <div class="mfunsPlayer-thumb"></div>
                    </div>
                </div>
                <div class="total">00:00</div>
            </div>
            <div class="mfunsPlayer-controller-full">
                <div class="mfunsPlayer-controller-full-icon"></div>
            </div>
        </div>

        <div class="mfunsPlayer-video-danmaku-root">
            {{ if danmaku.showDanmaku }}
            <div class="mfunsPlayer-video-danmaku-button open"></div>
            {{ else }}
            <div class="mfunsPlayer-video-danmaku-button close"></div>
            {{ /if }}
            <div class="mfunsPlayer-video-danmaku-set"></div>
            <div class="mfunsPlayer-input-box {{if typeof uid !== "number" }}noLogin{{/if}}">
                {{if typeof uid === "number"}}
                喵御宅Mfuns,发射(。゜ω゜)ノ!
                {{else}}
                请<a class="login_btn">登录</a>
                {{ /if}}

            </div>
        </div>

        <div class="mfunsPlayer-controller-right">
            <div class="mfunsPlayer-speed">倍速</div>
            {{if video.length>1}}
            <div class="mfunsPlayer-episode">选集</div>
            {{ /if }}
            <div class="mfunsPlayer-resolution">分辨率</div>
        </div>
    </div>
</div>